import styled from 'styled-components'

import {
  TransparentButton as BaseTransparentButton,
  disabledOpacity,
} from '@redriverpress/system'

// TransparentButton should be displayed like a link (underline decoration)
const TransparentButton = styled(BaseTransparentButton).attrs(
  ({ opacity, disabled }) => ({
    opacity: opacity === undefined && disabled ? disabledOpacity : opacity,
  })
)`
  text-decoration: underline;
  text-decoration-color: ${({ theme }) => theme.colors.blue700};

  &:hover,
  &:focus {
    color: ${({ theme }) => theme.colors.blue500};
  }

  &:disabled {
    color: inherit;
  }
`

export default TransparentButton
